// Safety-net timeout for the editor "Generating model…" blur overlay.
// The geometry worker normally finishes in under ~2 s, so this only fires when
// the worker hangs/crashes or a load callback never resolves — clearing the
// overlay so the user is never stuck behind an endless blur.
export const MODEL_LOADING_TIMEOUT_MS = 30000
